import n from "styled-components";
import { Icon as l } from "./atoms-v217.js";
import { SkeletonRow as g } from "./atoms-v2778.js";
import { Tag as c } from "./atoms-v241.js";
import { Text as x } from "./atoms-v243.js";
import { breakpoints as a } from "./atoms-v2125.js";
import { INPUT_EXPRESSIVE_HEIGHT as t, INPUT_PRODUCTIVE_HEIGHT_SMALL as d, INPUT_PRODUCTIVE_HEIGHT as p } from "./atoms-v2810.js";
const y = n.div`
  align-items: center;
  background-color: ${({ $isSkeleton: o, $variant: i }) => o || i === "expressive" ? "transparent" : "inherit"};
  border-radius: ${({ $variant: o, theme: i }) => o === "productive" ? i == null ? void 0 : i.get("tokens.radius.fieldSmall") : 0}px;
  color: ${({ $colorTheme: o = "light", $isDisabled: i, theme: r }) => i ? r == null ? void 0 : r.get(`tokens.text.${o}.disabled`) : r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  column-gap: 12px;
  display: flex;
  height: ${({ $variant: o }) => o === "expressive" ? t : d}px;
  inset: 1px 1px 1px auto;
  padding: 0 18px 0 12px;
  pointer-events: none;
  position: absolute;

  @media ${a.medium} {
    border-radius: ${({ $variant: o, theme: i }) => o === "productive" ? i == null ? void 0 : i.get("tokens.radius.fieldRadiusMed") : 0}px;
    height: ${({ $variant: o }) => o === "expressive" ? t : p}px;
  }
`, I = n(l)`
  color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.error`)};
`, w = n(g)`
  column-gap: 1px;
  display: flex;
  height: ${({ $variant: o }) => o === "expressive" ? t : d}px;
  justify-content: end;

  @media ${a.medium} {
    height: ${({ $variant: o }) => o === "expressive" ? t : p}px;
  }
`, S = n.div`
  flex: 1 1 auto;
  min-width: 0; /* let it shrink in flex row */
`, T = n.span`
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.compact-productive")) == null ? void 0 : i.toJS();
}}
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ $isDisabled: o, theme: i }) => o && `
    color: ${i == null ? void 0 : i.get("tokens.text.light.disabled")};
  `}

  ${({ $hasTag: o }) => o && `
    margin-right: 8px;
    min-width: 0;
  `}

  @media ${a.medium} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.compact-expressive")) == null ? void 0 : i.toJS();
}}
  }
`, E = n.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-right: ${({ $isMultiSelect: o }) => o ? "85px" : "30px"}; /* Leave space for icon */
  width: 100%;
`, R = n.div`
  align-items: flex-start;
  align-self: stretch;
  background-color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.background`)};
  border: 1px solid ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`tokens.border.${o}.light`)};
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.cardRadiusMed")}px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px;
`, C = n.div`
  align-items: center;
  background-color: ${({ $colorTheme: o = "light", $isSelected: i, theme: r }) => i ? r == null ? void 0 : r.get(`ui.button.ghost.${o}.active`) : "transparent"};
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.buttonSmallRounded")}px;
  color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`ui.button.ghost.${o}.text`)};
  cursor: pointer;
  display: flex;
  padding: 11px 16px;
  width: 100%;

  &:hover {
    background-color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`ui.button.ghost.${o}.hover`)};
  }

  ${({ $colorTheme: o = "light", $isFocused: i, $isSelected: r, theme: s }) => i && !r && `
    background-color: ${s == null ? void 0 : s.get(`ui.button.ghost.${o}.hover`)};
  `}
`, _ = n(x)`
  color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`ui.button.ghost.${o}.text`)};
  
  ${({ $isRight: o }) => o ? "margin-left: auto;" : "flex: 1;"}
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.compact-productive")) == null ? void 0 : i.toJS();
}}
`, H = n.div`
  align-self: center;
  background-color: ${({ $colorTheme: o = "light", theme: i }) => i == null ? void 0 : i.get(`tokens.border.${o}.dark`)};
  height: 30px;
  width: 1px;
`, P = n.div`
  align-items: center;
  display: flex;
  gap: 12px;
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
`, U = n(c)`
  > span {
    padding-bottom: 0;
  }
`;
export {
  E as ContentWrapper,
  H as Divider,
  I as ErrorIcon,
  y as IconContainer,
  R as MenuContainer,
  C as OptionContainer,
  _ as OptionLabel,
  S as RSWrapper,
  T as SelectedText,
  w as SkeletonInput,
  P as TagDividerContainer,
  U as TagForRemove
};
